import {
  Building2, HeartPulse, GraduationCap, Home, Leaf, Cpu, ShieldCheck, Clock, Zap, Recycle,
  MessageSquare, FileText, Users, CheckCircle, Target, Eye, Shield, Lightbulb, Phone, Mail, MapPin,
  type LucideIcon,
} from 'lucide-react'

export const iconMap: Record<string, LucideIcon> = {
  Building2, HeartPulse, GraduationCap, Home, Leaf, Cpu, ShieldCheck, Clock, Zap, Recycle,
  MessageSquare, FileText, Users, CheckCircle, Target, Eye, Shield, Lightbulb, Phone, Mail, MapPin,
}

export function getIcon(name: string): LucideIcon {
  return iconMap[name] || Leaf
}
